export const NavbarSliceConstants = {
  GetNavbarItems: 'Navbar/GetNavbarItems',
};
